<template>
<div class="index-wrap container">
  <div class="box" aria-label="提供跨省通办、省内通办、全市通办等专栏服务入口" wzades="提供跨省通办、省内通办、全市通办等专栏服务入口">
    <el-tabs v-model="nav" @tab-click="navChange" stretch class="card-tabs">
      <el-tab-pane v-for="(item, i) in tabsList" :key="i" :label="item.label" :name="item.nav"></el-tab-pane>
    </el-tabs>
    <component :is="currentNav"></component>
  </div>
</div>
</template>

<script>
import Interprovincial from './indexMods/Interprovincial.vue';
import City from './indexMods/City.vue';
import Province from './indexMods/Province.vue';
export default {
  components: {
    Interprovincial,
    City,
    Province
  },
  data() {
    return {
      nav: "Interprovincial",
      currentNav: null,
      tabsList: [{
        label: "跨省通办",
        nav: "Interprovincial"
      }, {
        label: "省内跨市通办",
        nav: "Province"
      }, {
        label: "全市通办",
        nav: "City"
      }]
    }
  },
  methods: {
    navChange() {
      let navObj = {
        Interprovincial,
        Province,
        City
      }
      this.currentNav = navObj[this.nav];
    }
  },
  mounted() {
    let nav = this.$route.query.nav;
    if (nav == 2) {
      this.nav = "Province";
      this.navChange();
    } else if (nav == 3) {
      this.nav = "City";
      this.navChange();
    } else {
      this.nav = "Interprovincial";
      this.navChange();
    }
  }
}
</script>

<style lang="scss" scoped>
.index-wrap {
  .box {
    margin-top: 70px;
  }
}
</style>
